export enum Routes {
  Login = '/login',
  ForgottenPassword = '/forgotten-password',
  ActivationCode = '/activation-code/:activationCode',
  ResetPassword = '/reset-password/:token',
  Home = '/home',
  Profile = '/Profile',
  Dashboard = '/dashboard',
  UserManagement = '/UserManagement',
  Organisations = '/Organisations',
  AuditLog = '/AuditLog',
  Consultants = '/Consultants',
  Procedures = '/Procedures',
  Inventories = '/Inventories',
  Preferences = '/Preferences',
  ChangeRequests = '/ChangeRequests',
  ScanReview = '/ScanReview',
  ScanCheck = '/ScanCheck',
  ConsultantAssign = '/ConsultantAssign',
  ConsultantReview = '/consultant-review',
  Migration = '/Migration',
  MigrationAdd = '/Migration/AddNew',
  MigrationDetail = '/Migration/Details',
}
